<script>
import StringUtils from '@/utils/stringUtils'

export default
{
    name: 'icon-tile',

    props:
    {
        title: { type: String, required: true },
        description: { type: String },
        icon: { type: String, required: true },
        disabled: { type: Boolean, default: false }
    },

    render () 
    {
        return (
            <div on-click={this.onTileClicked} class={`icon-tile ${this.disabled ? 'disabled' : ''}`} type='primary' ref='tile'>
                <div class='tile-inside'>
                    <img class='icon' src={this.icon} />
                    <br />
                    <inline-svg class='separator' src={require('@/assets/img/separator.svg')} />
                    <br />
                    <span class='title'>{ this.title }</span>
                    <span class='subtitle' v-show={!StringUtils.isEmptyString(this.description)} domPropsInnerHTML={ this.description } />
                </div>
            </div>
        )
    },

    data () 
    {
        return {
        }
    },

    mounted ()
    {
    },

    methods:
    {
        onTileClicked (event)
        {
            this.$emit('click', event, this)
        }
    },

    components:
    {
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.icon-tile
{
    cursor: pointer;
    background: var(--theme-content-background-color);
    padding: 6% 0 6% 0;
    border-radius: 25px;
    position: relative;
    box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.05);

    &::before, &::after
    {
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0px;
        top: 0px;
        border-radius: inherit;
        content: "";
    }
    &::before
    {
        box-shadow: rgba(0, 0, 0, 0.06) 0px 1px 2px 0px;
    }
    &::after
    {
        box-shadow: rgba(0, 0, 0, 0.02) 0px 0px 0px 1px;
    }

    .OnTablet({
        padding: 4% 1% 3% 1%;
    });
    
    .OnDesktop({
        padding-top: 2%;
        padding-bottom: 2%;
    });

    &.disabled
    {
        filter: grayscale(1);
    }

    .tile-inside
    {
        text-align: center;

        .icon
        {
            vertical-align: bottom;
            height: 10vh;
            object-fit: scale-down;

            .OnLargeMobile({ height: 8vh; });
            .OnTablet({ height: 8vh; });
            
            .OnDesktop({
                height: 8vh;
                width: 40%;
            });
        }

        .separator
        {
            width: 20%;
            margin: 3vh 0 2vh 0;
            fill: var(--theme-border-color-light);

            .OnDesktop({
                margin: 4vh 0 3vh 0;
            });
            .OnLarge({
                margin: 2.5vh 0;
            });
        }

        .title
        {
            color: var(--theme-text-color-light);
            font-family: Inter;
            font-weight: 500;
            font-size: 5vw;
            line-height: 100%;
            display: block;

            .OnTablet({
                font-size: 2.8vw;
            });

            .OnDesktop({
                font-size: 1.2vw;
            });
            
            .OnLarge({
                font-size: 1vw;
                font-weight: inherit;
            });

            .CapitalizeFirstLetter();
        }

        .subtitle
        {
            color: var(--theme-text-color-extra-light);
            font-family: Nunito;
            font-weight: bold;
            font-size: 4vw;
            display: block;
            margin-top: 1vh;

            .OnTablet({ 
                font-size: 2.5vw;
            });

            .OnDesktop({
                font-size: 1vw;
            });
            
            .OnLarge({
                font-size: 0.7vw;
            });

            .CapitalizeFirstLetter();
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/IconTile.vue